<template>
    <div>
        <vs-card class="text-center">
            <user-form
                :form-type="formType"
                :active-prompt="showUpdateForm"
                v-on:isClosed="showUpdateForm = false"
                v-on:userUpdated="updateUser($event)"
                :user="user"
                :title="formTitle"
            >
            </user-form>

            <div>
                <div class="profile-pic mb-3 mt-3">
                    <avatar v-bind:url="user.avatar" v-bind:on-upload-file="uploadFile"></avatar>
                    <h4 class="mt-3 mb-0">{{ user.name }}</h4>
                    <a :href="'mailto:' + user.username">{{ user.username }}</a>
                    <br /><span :class="'mt-3 badge badge-pill badge-' + statusClass[user.status]"> {{ user.status_text }} </span>
                </div>
                <hr class="custom-hr" />
                <div class="px-3 py-2">
                    <vs-row>
                        <vs-col
                            type="flex"
                            vs-justify="center"
                            vs-align="center"
                            vs-lg="6"
                            vs-xs="12"
                            class="text-center user-link"
                        >
                            <a @click="showForm('update')" href="#" class="text-dark d-flex align-items-center justify-content-center">
                                <i class="mdi mdi-developer-board mr-1"></i>Update Profile
                            </a>
                        </vs-col>

                        <vs-col
                            type="flex"
                            vs-justify="center"
                            vs-align="center"
                            vs-lg="6"
                            vs-xs="12"
                            class="text-center user-link"
                        >
                            <a @click="showForm('password')" href="#" class="text-dark d-flex align-items-center justify-content-center">
                                <i class="mdi mdi-developer-board mr-1"></i>Change Password
                            </a>
                        </vs-col>
                    </vs-row>
                </div>
            </div>
        </vs-card>

        <vs-card>
            <h3 class="card-title mb-0">Active sessions</h3>
            <div class="mb-3"><span>You can destroy suspicious sessions to protect your data</span></div>

            <vs-table
                id="tokens-table"
                ref="table"
                stripe
                pagination
                max-items="20"
                search
                :data="user.tokens"
                class="text-nowrap"
            >
                <template slot="thead">
                    <vs-th sort-key="id">IP</vs-th>
                    <vs-th sort-key="name">City</vs-th>
                    <vs-th sort-key="status">Browser</vs-th>
                    <vs-th sort-key="created_at">Created At</vs-th>
                    <vs-th sort-key="updated_at">Updated At</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="token" :key="i" v-for="(token, i) in data">
                        <vs-td>
                            {{token.ip}}
                        </vs-td>

                        <vs-td>
                            {{ token.city }}, {{ token.country }}
                        </vs-td>

                        <vs-td style="overflow: hidden; text-overflow: ellipsis; max-width: 250px;">
                            {{ token.user_agent }}
                        </vs-td>

                        <vs-td>
                            <span class="text-muted">{{ token.created_at }}</span>
                        </vs-td>

                        <vs-td>
                            <span class="text-muted">{{ token.updated_at }}</span>
                        </vs-td>

                        <vs-td>
                            <a @click="removeToken(token.uid, i)"><span class="badge badge-pill badge-danger">Remove</span></a>
                        </vs-td>
                    </vs-tr>
                </template>

            </vs-table>
        </vs-card>
    </div>
</template>

<script>
    import {UsersService} from "../../services/users.service";
    import $store from './../../store';
    import UserForm from "./Form";
    import Avatar from "./Avatar";
    import NProgress from "nprogress";

    export default {
        name : 'User',
        data:  () => ({
            user: {
                id: 0,
                name: '',
                username: '',
                status: 0,
                status_text:'',
                updated_at:'',
                tokens: [],
                avatar:''
            },
            formType: 'update',
            formTitle: 'Update data',
            showUpdateForm: false,
            statusClass: {
                0: 'danger',
                1: 'success'
            }
        }),
        props: ['id'],
        components: { UserForm, Avatar },
        watch: {
            user: function(user) {
                $store.commit('SET_TITLE', user.name)
            }
        },
        async created() {
            NProgress.start();
            UsersService.one(this.id, {expand: 'tokens'})
                .then(data => {
                    NProgress.done();
                    this.user = data.data;
                })
                .catch(() => {
                    NProgress.done();
                    this.$vs.notify({
                        color: "danger",
                        title: "Error!",
                        text: "User data cannot be loaded"
                    });
                });
        },
        methods: {
            uploadFile(file) {
                NProgress.start();
                return UsersService.uploadAvatar(this.user.id, file)
                    .then( response => {
                        NProgress.done();
                        this.user.avatar = response.data.url + '?' + Math.random();
                        if (this.user.id === this.$store.state.user.currentUser.id) {
                            this.$store.commit('user/SET_AVATAR', this.user.avatar);
                        }
                    })
                    .catch(error => {
                        NProgress.done();
                        this.$vs.notify({
                            color: "danger",
                            title: error.name,
                            text: error.message
                        });
                    });
            },
            showForm: function(formType) {
                this.formType = formType;
                this.formTitle = formType==='update' ? 'Update ' + this.user.name :
                    formType === 'password' ? 'Change password' : this.formTitle;
                this.showUpdateForm = true;
            },
            updateUser: function (user) {
                this.user.name = user.name;
                this.user.username = user.username;
                this.user.status = user.status;
                this.user.status_text = user.status_text;

                if (user.id === this.$store.state.user.currentUser.id) {
                    this.$store.commit('user/SET_USER', user);
                }
                this.$store.commit('SET_TITLE', user.name);
            },
            removeToken: function (uid, i) {
                NProgress.start();
                UsersService.removeToken(this.user.id, uid)
                    .then( () => {
                        NProgress.done();
                        this.user.tokens.splice(i, 1);

                        this.$vs.notify({
                            color: "success",
                            title: "Token is revoked",
                            text: "Feel safe"
                        });
                    })
                    .catch( () => {
                        NProgress.done();
                        this.$vs.notify({
                            color: "danger",
                            title: "Error!",
                            text: "Error on revoking token"
                        });
                    });
            }
        }
    }
</script>


<style lang="scss">
.ps {
    height: 100px;
}

#tokens-table .vs-table--pagination {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.user-link {
    border-bottom: 1px solid #e8e8e8;
    padding: 0.5em 0;

    &:first-of-type{
        padding-top: 0;
    }
    &:last-of-type {
        border-bottom: none;
    }
    & > a {
        justify-content: left !important;
    }
    @media (min-width: 601px) {
        & {
            border-bottom: none;
            border-right: 1px solid #e8e8e8;

            &:first-of-type{
                padding-top: 0.5em;
            }
            &:last-of-type {
                border-right: none;
            }
            & > a {
                justify-content: center !important;
            }
        }
    }
}
</style>
